import http from './http';
import { IDomainWhitelistConfig } from '../resource';

export const getDomainWhitelist = async (): Promise<{ success: boolean } & IDomainWhitelistConfig> => {
  return await http.get('/settings/domain-whitelist');
};

export const updateDomainWhitelist = async (
  domains: string[]
): Promise<{ success: boolean } & IDomainWhitelistConfig> => {
  return await http.put('/settings/domain-whitelist', { domains });
};
